import { createMultiStyleConfigHelpers as e } from "@chakra-ui/styled-system";
const t = e(["container"]), i = t.defineMultiStyleConfig({
  baseStyle: () => ({
    container: {
      flexDirection: "row"
    }
  }),
  variants: {
    rowLayout: () => ({
      container: {
        flexDirection: "column",
        alignItems: "start,"
      }
    })
  }
});
export {
  i as default
};
